import {createContext} from "react";


export const UserContext = createContext(null);


export const SnackbarContext = createContext({});

export const EngInfoContext = createContext(null);
